import { HonorsSet } from './honors-set/honors-set';
import { ToraxHttp } from './../utils/custom-http.svc';
import { Injectable, EventEmitter } from '@angular/core';


@Injectable()

export class HonorsSetsData {
    private url = 'api/honorsSets';


    constructor(
        private toraxHttp: ToraxHttp
    ) { }

    delete(id: number) {
        return this.toraxHttp.getDeleteResponse(`${this.url}/delete/${id}`);
    }

    getList(baseQuery: any) {
        return this.toraxHttp.post(`${this.url}/List`, baseQuery);
    }

    createAndPrintHonorsSetLetters(honorID: number) {
        return this.toraxHttp.get(`${this.url}/createAndPrintHonorsSetLetters?honorID=${honorID}`);
    }

    get(id: number) {
        return this.toraxHttp.get(`${this.url}/${id || 0}`);
    }

    getEdit(id: number) {
        return this.toraxHttp.get(`${this.url}/${id || 0}/edit`);
    }

    update(honorsSet: HonorsSet) {
        return this.toraxHttp.update(this.url, honorsSet);
    }

    getAdd()  {
        return this.toraxHttp.get(`${this.url}/add`);
    }

     recIn(id: number) {
      return this.toraxHttp.recIn(this.url, id);
  }

 public updatedEvent = new EventEmitter<number>();


    private onUpdated(id: number): void {
        if (this.updatedEvent) {
            this.updatedEvent.emit(id);
        }
    }
}
